"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var StateChoice_1 = __importDefault(require("./StateChoice"));
var DistrictChoice_1 = __importDefault(require("./DistrictChoice"));
var searchParamsSlice_1 = require("../../../features/searchParams/searchParamsSlice");
var AddressAutoComplete_1 = __importDefault(require("./AddressAutoComplete"));
var addressGeometries_1 = require("../../../helpers/addressGeometries");
var languageSlice_1 = require("../../../features/languages/languageSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlAddressPicker = function (_a) {
    var addressData = _a.addressData, location = _a.location, districtId = _a.districtId, stateId = _a.stateId, onSave = _a.onSave;
    var dispatch = react_redux_1.useDispatch();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var _b = react_1.useState(), selectedDistrict = _b[0], setSelectedDistrict = _b[1];
    var _c = react_1.useState({
        addressData: addressData || {
            state: '',
            district: '',
            address: '',
        },
        location: location || {},
        districtId: districtId || '',
        stateId: stateId || '',
    }), locationData = _c[0], setLocationData = _c[1];
    var _d = react_1.useState(), polygon = _d[0], setPolygon = _d[1];
    var _e = react_1.useState(false), isDistrictCompleted = _e[0], setIsDistrictCompleted = _e[1];
    var _f = react_1.useState(), selectedDistrictCenter = _f[0], setSelectedDistrictCenter = _f[1];
    react_1.useEffect(function () {
        setIsDistrictCompleted(!!locationData.districtId);
    }, [locationData.districtId]);
    react_1.useEffect(function () {
        if (locationData.stateId) {
            dispatch(searchParamsSlice_1.setAppliedStates([String(locationData.stateId)]));
            dispatch(searchParamsSlice_1.getDistricts(locationData.stateId, false));
        }
    }, [locationData.stateId]);
    var handleClearAddress = function () {
        setLocationData(function (prevState) { return (__assign(__assign({}, prevState), { location: location, addressData: __assign(__assign({}, prevState.addressData), { address: '' }) })); });
        onSave({
            addressData: null,
            location: {},
        });
    };
    var handleStateDistrictChange = function (arg, key, addressKey) {
        setLocationData(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), (_a = {}, _a[key] = String(arg.govId), _a.addressData = __assign(__assign({}, prevState.addressData), (_b = {}, _b[addressKey] = arg.text, _b)), _a)));
        });
    };
    var handleChangeCurrentLocation = function (location, customAddress) {
        var latLngCoordinates = addressGeometries_1.getLatLngCoordinates(selectedDistrict.geometry.coordinates[0]);
        setLocationData(function (prevState) { return (__assign(__assign({}, prevState), { location: location, addressData: __assign(__assign({}, prevState.addressData), { address: customAddress }) })); });
        setPolygon(latLngCoordinates);
    };
    var handleChangeSelectedDistrict = function (district) {
        if (district) {
            setSelectedDistrict(district);
            var latLngCoordinates = addressGeometries_1.getLatLngCoordinates(district.geometry.coordinates[0]);
            setPolygon(latLngCoordinates);
            setSelectedDistrictCenter(district.center);
        }
        else {
            setSelectedDistrict(null);
        }
    };
    var handleSaveAddressData = function (marker) {
        var currentLocation = __assign({}, locationData);
        currentLocation.location = marker;
        onSave(currentLocation);
    };
    var resetAddressValue = function () {
        onSave({
            addressData: null,
        });
        setLocationData(function (prevState) { return (__assign(__assign({}, prevState), { addressData: __assign(__assign({}, prevState.addressData), { address: '' }) })); });
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.state_district_columns },
            react_1.default.createElement(StateChoice_1.default, { defaultValue: locationData.stateId, currentLanguage: currentLanguage, handleStateDistrictChange: handleStateDistrictChange }),
            react_1.default.createElement(DistrictChoice_1.default, { defaultValue: locationData.districtId, currentLanguage: currentLanguage, handleStateDistrictChange: handleStateDistrictChange, handleChangeSelectedDistrict: handleChangeSelectedDistrict })),
        react_1.default.createElement("div", null,
            react_1.default.createElement(AddressAutoComplete_1.default, { addressData: locationData.addressData, currentLocation: locationData.location, isDistrictCompleted: isDistrictCompleted, polygon: polygon, selectedDistrict: selectedDistrict, selectedDistrictCenter: selectedDistrictCenter, handleClearAddress: handleClearAddress, handleChangeCurrentLocation: handleChangeCurrentLocation, handleSaveAddressData: handleSaveAddressData, resetAddressValue: resetAddressValue }))));
};
exports.default = react_1.memo(BlAddressPicker);
